/**
 * smallLabel -> string = title superior (small)
 * label -> string = titulo
 * value -> conteúdo
 */

import React from "react";
import './CardContact.css'

const CardContact = props => {
    const { smallLabel, label, value, full } = props
    return (
        <div className="container-card-contact" style={{...(full && {width: '100%'})}}>

            <span className="primary300">{smallLabel}</span>
            <div className="mg-bot-30" style={{
                marginTop: smallLabel ? '15px' : '35px',
            }}>
                <span className="text-title-secondary" dangerouslySetInnerHTML={{ __html: label }}></span>
                <span dangerouslySetInnerHTML={{ __html: value }}></span>
            </div>
        </div>
    )
}

export default CardContact